import IMG1 from "../../assets/amazon.png";
import IMG2 from "../../assets/omni.png";
import IMG3 from "../../assets/project3.png";

export const projects = [
  {
    image: IMG1,
    github: "https://github.com/AdnanAbidMERN/hosted-amazon",
    live: "https://amazoneclone.cyclic.app/",
    title: "Amazon Clone",
    features: ["MongoDB", "Express", "React", "ContextAPI", "Redux", "Node"],
  },
  {
    image: IMG2,
    github: "https://github.com/AdnanAbidMERN/OmniFood-deployed",
    live: "https://omnifood-adab.netlify.app/",
    title: "Landing Page Of Diet Startup",
    features: ["HTML", "CSS", "Javascript", "Responsive", "UI/UX", "Landing"],
  },
  {
    image: IMG3,
    github: "https://github.com/AdnanAbidMERN/MyPortfolio",
    live: "https://portfolio-adnanmern.netlify.app/",
    title: "My Portfolio",
    features: ["MongoDB", "Express", "React", "ContextAPI", "Redux", "Node"],
  },
];
